import React from 'react';
import LegalDocument from '../Common/LegalDocument';
import { useLocale } from '../../localization/LocaleContext';
import { getOnlinePaymentsContent } from '../../localization/onlinePaymentsContent';

export default function OnlinePayments() {
    const { locale, toLocalizedPath } = useLocale();
    const content = getOnlinePaymentsContent(locale, {
        privacyPolicyPath: toLocalizedPath('privacyPolicy')
    });

    return (
        <LegalDocument
            heading={content.heading}
            lastUpdated={content.lastUpdated}
            introHtml={content.introHtml}
            sections={content.sections}
        />
    );
}